import axios from 'axios';
import store from '../store';
// import router from "../router";
import { Toast } from 'vant';
// 创建axios实例
const service = axios.create({
	// api 的 VUE_APP_URL  process.env.VUE_APP_URL
	// baseURL: 'http://192.168.1.191:8082/',
	// baseURL: 'https://setonapi.wsandos.com/',
	baseURL: 'https://xdzsht.cdn.cc/',
	// 请求超时时间(因为需要调试后台,所以设置得比较大)
	timeout: 50000,
	token: '',
	config: {},
});

/** 定义默认配置 */
service.defaults.headers = {
	'Content-Type': 'application/json;charset=UTF-8',
	token: '',
};
// request拦截器,在请求之前做一些处理
service.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem('token') || store.state.permissions.token || '';
		if (token) {
			// 给请求头添加laohu-token
			config.headers['token'] = token;
		}
		config = {
			...config,
			...service.config,
		};
		return config;
	},
	(error) => {
		// for debug
		console.log(error);
		return Promise.reject(error);
	}
);

// response 拦截器,数据返回后进行一些处理
service.interceptors.response.use(
	(response) => {
		/**
		 * code为非20000是抛错 可结合自己业务进行修改
		 */
		const res = response.data;
		if (res.code == 200) {
			return res;
		} else {
			if (res.code == 401) {
				store.dispatch('permissions/clear');

				const token = localStorage.getItem('token');
				if (token) {
					localStorage.removeItem('token');
					Toast(res.msg);
				}
			}
			return Promise.reject(res);
		}
	},
	(err) => {
		// Toast.fail()
		if (err.response) {
			switch (err.response.status) {
				case 400:
					err.message = err.response.data.msg;
					Toast(err.response.data.msg);
					break;
				case 401:
					sessionStorage.removeItem('token');
					store.dispatch('permissions/clear');
					err.message = '未授权，请重新登录';
					return Promise.reject(err.response.message);
					break;
				case 403:
					err.message = '拒绝访问';
					break;
				case 404:
					err.message = '请求错误,未找到该资源';
					break;
				case 405:
					err.message = '请求方法未允许';
					break;
				case 408:
					err.message = '请求超时';
					break;
				case 500:
					err.message = '服务器端出错';
					break;
				case 501:
					err.message = '网络未实现';
					break;
				case 502:
					err.message = '网络错误';
					break;
				case 503:
					err.message = '服务不可用';
					break;
				case 504:
					err.message = '网络超时';
					break;
				case 505:
					err.message = 'http版本不支持该请求';
					break;
				default:
					err.message = `连接错误${err.response.status}`;
			}
		}
		return Promise.reject('请求失败');
	}
);
export default service;
